export const CreateClassValues = {
  Default: "default",
  ArrowWithBackAndFord: "arrowWithBackAndFord",
  InvertedArrowWithBackAndFord: "invertedArrowWithBackAndFord",
  ArrowWithoutBack: "arrowWithoutBack",
  InvertedArrowWithoutBack: "invertedArrowWithoutBack",
  Semifinals: "semiFinals",
  InvertedSemifinals: "invertedSemiFinals",
  Finals: "finals",
} as const;

export const createClass = (props: {
  isReverse: boolean;
  isFinals: boolean;
  isSemifinals: boolean;
  isShowArrowFront: boolean;
  isShowArrowBack: boolean;
}): (typeof CreateClassValues)[keyof typeof CreateClassValues] => {
  if (props.isFinals) {
    return CreateClassValues.Finals;
  }

  if (props.isReverse && props.isSemifinals) {
    return CreateClassValues.InvertedSemifinals;
  }

  if (props.isSemifinals) {
    return CreateClassValues.Semifinals;
  }

  if (props.isReverse && props.isShowArrowFront && !props.isShowArrowBack) {
    return CreateClassValues.InvertedArrowWithoutBack;
  }

  if (props.isReverse && props.isShowArrowFront && props.isShowArrowBack) {
    return CreateClassValues.InvertedArrowWithBackAndFord;
  }

  if (props.isShowArrowFront && props.isShowArrowBack) {
    return CreateClassValues.ArrowWithBackAndFord;
  }

  if (props.isShowArrowFront && !props.isShowArrowBack) {
    return CreateClassValues.ArrowWithoutBack;
  }

  return CreateClassValues.Default;
};
